import { useState } from 'react'

import { Card } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import PlayCircleOutlineIcon from 'mdi-react/PlayCircleOutlineIcon'

import { Translation } from '@/app/translations/Translation'

import { RunWorkflowModal } from './RunWorkflowModal'

type WorkflowEntry = {
  id: string
  name: string
  description: string
}

const WORKFLOWS: WorkflowEntry[] = [
  {
    id: 'mobile-asset-return-dunning',
    name: 'Mobile Asset Return Dunning',
    description:
      'Sends dunning notifications to customers with unreturned mobile assets. Can target a single customer or run across all eligible customers. Skips weekends automatically.',
  },
]

export const WorkflowsPage = () => {
  const [activeWorkflow, setActiveWorkflow] = useState<string | null>(null)

  return (
    <div className="p-6">
      <h1 className="mb-1 text-xl font-bold">
        <Translation id="Workflows" />
      </h1>
      <p className="mb-6 text-sm text-gray-500">
        <Translation id="Manually trigger workflows for testing. Not available in production." />
      </p>

      <div className="flex flex-col gap-4">
        {WORKFLOWS.map(workflow => (
          <Card key={workflow.id} noPadding>
            <div className="flex items-center justify-between p-5">
              <div className="flex items-center gap-3">
                <PlayCircleOutlineIcon className="shrink-0 text-gray-400" size={24} />
                <div>
                  <p className="font-medium">
                    <Translation id={workflow.name} />
                  </p>
                  <p className="mt-0.5 text-sm text-gray-500">
                    <Translation id={workflow.description} />
                  </p>
                </div>
              </div>
              <Button
                variant="secondary"
                className="ml-6 shrink-0"
                onClick={() => setActiveWorkflow(workflow.id)}
              >
                <Translation id="Run" />
              </Button>
            </div>
          </Card>
        ))}
      </div>

      <RunWorkflowModal
        isOpen={activeWorkflow === 'mobile-asset-return-dunning'}
        onClose={() => setActiveWorkflow(null)}
      />
    </div>
  )
}
